

export const frodoReviewerReviewHinge = {
  _id: 'frodoReviewerReviewHingeId',
  email: 'frodo@email.com',
  profileReviewId: 'frodoProfileReviewHingeId',
  reviewerProfileId: 'frodoReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Frodo! This will really help me!',
  profileReviewedFirstName: 'Luigi',
}

export const hollyReviewerReviewBumble = {
  _id: 'hollyReviewerReviewBumbleId',
  email: 'holly@email.com',
  profileReviewId: 'hollyProfileReviewBumbleId',
  reviewerProfileId: 'hollyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Holly! This will really help me!',
  profileReviewedFirstName: 'Luigi',
}

export const gatsbyReviewerReviewTinder = {
  _id: 'gatsbyReviewerReviewTinderId',
  email: 'gatsby@email.com',
  profileReviewId: 'gatsbyProfileReviewTinderId',
  reviewerProfileId: 'gatsbyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Gatsby! This will really help me!',
  profileReviewedFirstName: 'Luigi',
}